import { MutationTree } from 'vuex'

import { AuthState } from './state'

export const UPDATE_TOKEN = 'UPDATE_TOKEN'
export const UPDATE_TOKEN_V2 = 'UPDATE_TOKEN_V2'

const mutations: MutationTree<AuthState> = {
  [UPDATE_TOKEN] (state, token: string | null) {
    state.token = token
  },

  [UPDATE_TOKEN_V2] (state, tokenV2: string | null) {
    state.tokenV2 = tokenV2
  }
}

export default mutations
